document.addEventListener('DOMContentLoaded', function () {
  const stepButtons = this.querySelectorAll('.method-steps__step');
  const contentContainers = document.querySelectorAll( '.method-steps__content-container');

  function hideAllContainers() {
    contentContainers.forEach((container) => {
      container.classList.add('hidden');
    });
  }

  function removeActive() {
    stepButtons.forEach((step) => {
      step.classList.remove('active');
    });
  }

  function showContainer(stepIndex) {
    const targetContainer = document.getElementById(stepIndex.toString());
    if (targetContainer) {
      targetContainer.classList.remove('hidden');
    } else {
      console.error(`Container with ID ${stepIndex} not found`);
    }
  }

  function handleStepClick(event) {
    const buttonId = event.currentTarget.id;
    const stepNumber = buttonId.replace('step-', '');

    hideAllContainers();
    removeActive();
    showContainer(stepNumber);
    event.currentTarget.classList.add('active');
  }

  stepButtons.forEach((button) => {
    button.addEventListener('click', handleStepClick);
  });

  if (stepButtons.length > 0 && contentContainers.length > 0) {
    hideAllContainers();
    showContainer(1);
    stepButtons[0].classList.add('active');
  }
});
